export const GLOBAL_CONFIG_KEYS = {
  MIN_THRESHOLD_FOR_TAGGING_DUPLICATE: 'MinThresholdForTaggingDuplicate',
} as const;
